/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './meal-details.reducer';

export const MealDetailsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const mealDetailsEntity = useAppSelector(state => state.mealDetails.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mealDetailsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.mealDetails.detail.title">MealDetails</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.mealDetails.id">Id</Translate>
            </span>
          </dt>
          <dd>{mealDetailsEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.mealDetails.active">Active</Translate>
            </span>
          </dt>
          <dd>{mealDetailsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.mealDetails.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{mealDetailsEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.mealDetails.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{mealDetailsEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.mealDetails.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{mealDetailsEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.mealDetails.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{mealDetailsEntity.microSec}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mealDetails.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{mealDetailsEntity.glucoUser ? mealDetailsEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mealDetails.mealDetailsSchedule">Meal Details Schedule</Translate>
          </dt>
          <dd>{mealDetailsEntity.mealDetailsSchedule ? mealDetailsEntity.mealDetailsSchedule.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mealDetails.recipeMealDetails">Recipe Meal Details</Translate>
          </dt>
          <dd>{mealDetailsEntity.recipeMealDetails ? mealDetailsEntity.recipeMealDetails.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/meal-details" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/meal-details/${mealDetailsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MealDetailsDetail;
